import React from "react";
import { ContainerOutlined, MedicineBoxOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ChoiceOverview from "../ChoiceOverview";
import GamePage from "./GamePage";

const Lieing: React.FC = () => {
    const { t } = useTranslation();
    const variants = [
        {
            icon: <ContainerOutlined />,
            titleKey: "games.details.lieingOverview.variants.cards.title",
            descriptionKey: "games.details.lieingOverview.variants.cards.description",
            to: "lieingCards",
        },
        {
            icon: <MedicineBoxOutlined />,
            titleKey: "games.details.lieingOverview.variants.cubes.title",
            descriptionKey: "games.details.lieingOverview.variants.cubes.description",
            to: "lieingCubes",
        },
    ];

    return (
        <GamePage
            game="lieingOverview"
            tagColor="gold"
            instructionIcons={[<ContainerOutlined key="choose" />, <MedicineBoxOutlined key="play" />]}
        >
            <ChoiceOverview
                title=""
                subtitle=""
                items={variants.map((variant) => ({
                    to: variant.to,
                    icon: variant.icon,
                    title: t(variant.titleKey),
                    description: t(variant.descriptionKey),
                }))}
                variant="lieing"
            />
        </GamePage>
    );
};

export default Lieing;
